import _ from 'underscore';

import { combineReducers } from 'redux';

import ACTIONS from './actions';

import * as ProgramTypes from '../calendar/programTypes';

const timelineInitialStatus = [
    { name: 'SUN', status: false },
    { name: 'MON', status: false },
    { name: 'TUE', status: false },
    { name: 'WED', status: false },
    { name: 'THU', status: false },
    { name: 'FRI', status: false },
    { name: 'SAT', status: false }
];

const fixedInitialStatus = [
    { name: 'DAY 1', status: false },
    { name: 'DAY 2', status: false },
    { name: 'DAY 3', status: false },
    { name: 'DAY 4', status: false },
    { name: 'DAY 5', status: false },
    { name: 'DAY 6', status: false },
    { name: 'DAY 7', status: false }
];

const getInitialStatus = key => {
    let programType = parseInt(key.substr(0, 1));
    if (ProgramTypes.isProgram(programType)) {
        return fixedInitialStatus;
    }
    return timelineInitialStatus;
};

const getDayHeaderKey = (key, dayHeader) => {
    return _.findKey(getInitialStatus(key), { name: dayHeader.name });
};

const calendarCollapseConfig = (state = {}, action) => {
    switch (action.type) {
        case ACTIONS.CALENDAR_LOAD_DAY_HEADERS:
            let exists = state[action.key];
            if (exists) return state;
            return {
                ...state,
                [action.key]: getInitialStatus(action.key)
            };
        case ACTIONS.CALENDAR_TOGGLE_DAY_HEADER_TOGGLE:
            let dayHeaderKey = getDayHeaderKey(action.key, action.dayHeader);
            let newState = { ...state };
            newState[action.key][dayHeaderKey] = {
                ...newState[action.key][dayHeaderKey],
                status: !newState[action.key][dayHeaderKey].status
            };
            return newState;
        case ACTIONS.EXPAND:
            return {
                ...state
            };
        default:
            return state;
    }
};

export default combineReducers({
    calendarCollapseConfig
});
